import { makeStyles } from '@material-ui/styles';

export const useUploadRulesStyles = makeStyles((theme: Theme) => ({
  root: {
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  content: {
    padding: theme.spacing(2),
  },
  warning: {
    display: 'flex',
    justifyContent: 'center',
  },
  warningIcon: {
    marginRight: '10px',
    color: '#d6c01a',
    fontSize: '25px',
  },
  actions: {
    display: 'flex',
    marginTop: 0,
    padding: theme.spacing(2),
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 345,
  },
}));
